import React, { Component } from 'react';
import EmployeeProfile from '../components/Employee/EmployeeProfile';
import WithMyEmployeeData from '../components/WithMyEmployeeData';

class MyProfileView extends Component {
  render() {
    return (
      <WithMyEmployeeData>
        <EmployeeProfile myProfile />
      </WithMyEmployeeData>
    );
  }
}


export default MyProfileView;
